function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from "react";
import { Tabs, notification, Skeleton, List, Button, Statistic, Table, DatePicker, Divider, Spin, Tag, Breadcrumb } from "antd";
import { ListUl, Cash, BoxFill, ShieldFillExclamation } from "react-bootstrap-icons";
import { Row, Col } from "react-bootstrap";
import moment from 'moment';
import Common from "../components/includes/Common";
import dayjs from 'dayjs';
import ProvisionHistory from "../components/ProvisionHistory";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;
var Stock = function Stock() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    dataChanged = _useState2[0],
    setDataChanged = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    dataError = _useState4[0],
    setDataError = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isDataLoading = _useState6[0],
    setIsDataLoading = _useState6[1];
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    sellableCount = _useState8[0],
    setSellableCount = _useState8[1];
  var _useState9 = useState(0),
    _useState0 = _slicedToArray(_useState9, 2),
    lowInventoryCount = _useState0[0],
    setLowInventoryCount = _useState0[1];
  var _useState1 = useState([]),
    _useState10 = _slicedToArray(_useState1, 2),
    inventory = _useState10[0],
    setInventory = _useState10[1];
  useEffect(function () {
    setIsDataLoading(true);
    axios.all([axios.get("".concat(Common.baseApiUrl, "getinventorydata/").concat(Common.currentUser.id))]).then(function (response) {
      if (response[0].data.status == 200) {
        setInventory([]);
        response[0].data.sellables_point_of_sale.forEach(function (e) {
          setInventory(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              item: e.sellable && e.sellable.label,
              cat: e.sellable && e.sellable.sellable_category && e.sellable.sellable_category.label,
              price: e.sellable && e.sellable.price,
              consignation_price: e.sellable && e.sellable.consignation_price,
              recharge_price: e.sellable && e.sellable.recharge_price,
              pos: e.point_of_sale && e.point_of_sale.label,
              purchase_price: e.sellable && e.sellable.purchase_price,
              qte: e.available_quantity
            }]);
          });
        });
        setSellableCount(response[0].data.sellables_count);
        setLowInventoryCount(response[0].data.low_inventory_count);
      } else {
        setDataError(response[0].data.message);
      }
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [dataChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Row, {
      children: /*#__PURE__*/_jsxs(Col, {
        children: [/*#__PURE__*/_jsx(Breadcrumb, {
          items: [{
            title: /*#__PURE__*/_jsx("span", {
              children: "ALO-GAZ"
            })
          }, {
            title: "Etat du stock"
          }]
        }), /*#__PURE__*/_jsx("br", {})]
      })
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Row, {
      children: [/*#__PURE__*/_jsxs(Col, {
        lg: 8,
        md: 8,
        sm: 12,
        children: [/*#__PURE__*/_jsx("div", {
          style: {
            padding: "24px",
            borderRadius: "6px",
            background: "#FFFFFF"
          },
          children: /*#__PURE__*/_jsxs(Row, {
            children: [/*#__PURE__*/_jsx(Col, {
              lg: 6,
              md: 6,
              sm: 6,
              children: /*#__PURE__*/_jsx(Statistic, {
                styles: {
                  content: {
                    color: '#0749A5',
                    fontSize: "62px"
                  }
                },
                prefix: /*#__PURE__*/_jsx(BoxFill, {
                  size: "26px"
                }),
                title: /*#__PURE__*/_jsx("b", {
                  children: "Total articles"
                }),
                value: sellableCount
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: 6,
              md: 6,
              sm: 6,
              children: /*#__PURE__*/_jsx(Statistic, {
                styles: {
                  content: {
                    color: '#EC762D',
                    fontSize: "62px"
                  }
                },
                prefix: /*#__PURE__*/_jsx(ShieldFillExclamation, {
                  size: "26px"
                }),
                title: /*#__PURE__*/_jsx("b", {
                  children: "Alerte stock faible"
                }),
                value: lowInventoryCount
              })
            })]
          })
        }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(Table, {
          size: "small",
          columns: [{
            title: /*#__PURE__*/_jsx("b", {
              children: "PDV"
            }),
            dataIndex: "pos",
            render: function render(v) {
              return /*#__PURE__*/_jsx(Tag, {
                color: "default",
                children: v
              });
            },
            key: "pos"
          }, {
            title: /*#__PURE__*/_jsx("b", {
              children: "Article"
            }),
            dataIndex: "item",
            render: function render(v) {
              return /*#__PURE__*/_jsx("b", {
                children: v
              });
            },
            key: "item"
          }, {
            title: /*#__PURE__*/_jsx("b", {
              children: "Cat\xE9gorie"
            }),
            dataIndex: "cat",
            render: function render(v) {
              return /*#__PURE__*/_jsx("b", {
                children: v
              });
            },
            key: "cat"
          }, {
            title: /*#__PURE__*/_jsx("b", {
              children: "Prix Recharge"
            }),
            dataIndex: "recharge_price",
            render: function render(v) {
              return /*#__PURE__*/_jsx("b", {
                children: v
              });
            },
            key: "price"
          }, {
            title: /*#__PURE__*/_jsx("b", {
              children: "Prix consign."
            }),
            dataIndex: "consignation_price",
            render: function render(v) {
              return /*#__PURE__*/_jsx("b", {
                children: v
              });
            },
            key: "consignation_price"
          }, {
            title: /*#__PURE__*/_jsx("b", {
              children: "Qte Disp."
            }),
            dataIndex: "qte",
            render: function render(v) {
              return /*#__PURE__*/_jsx("b", {
                children: v.toLocaleString('Fr')
              });
            },
            key: "qte"
          }],
          bordered: true,
          sticky: true,
          loading: isDataLoading,
          dataSource: inventory,
          scroll: {
            y: 520
          }
        })]
      }), /*#__PURE__*/_jsx(Col, {
        children: /*#__PURE__*/_jsx("div", {
          style: {
            background: "#F9EBE2",
            padding: "24px",
            borderRadius: "7px"
          },
          children: /*#__PURE__*/_jsx(ProvisionHistory, {})
        })
      })]
    })]
  });
};
export default Stock;